/* src/app/settings/campaigns-limits/campaigns-limits.component.scss */
.cl-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}
.cl-badge--safe {
  background-color: #e6f4ea;
  color: #1e8e3e;
}
.cl-badge--moderate {
  background-color: #fef3e2;
  color: #e37400;
}
.cl-badge--risky {
  background-color: #fce8e6;
  color: #c5221f;
}
.cl-stat-card {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 16px 20px;
}
.cl-stat-card .cl-stat-value {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 4px;
}
.cl-stat-card .cl-stat-label {
  font-size: 12px;
  color: #6c757d;
  margin-bottom: 0;
}
.cl-edit-btn {
  margin-left: 16px;
}
.cl-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.48);
  z-index: 1060;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
.cl-modal-dialog {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  width: 100%;
  max-width: 660px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.cl-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e9ecef;
  flex-shrink: 0;
}
.cl-modal-body {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
}
.cl-modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 12px 20px;
  border-top: 1px solid #e9ecef;
  flex-shrink: 0;
}
.cl-btn-close {
  background: none;
  border: none;
  color: #6c757d;
  font-size: 14px;
  cursor: pointer;
  padding: 4px 6px;
  line-height: 1;
  border-radius: 4px;
}
.cl-btn-close:hover {
  color: #1a1a1a;
  background: #f0f0f0;
}
.cl-level-table {
  border-collapse: collapse;
}
.cl-level-table thead tr th {
  padding: 8px 12px;
  text-align: left;
  font-size: 11px;
  font-weight: 600;
  color: #6c757d;
  border-bottom: 2px solid #e9ecef;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.cl-level-table .cl-level-row {
  cursor: pointer;
  transition: background 0.12s;
}
.cl-level-table .cl-level-row td {
  padding: 12px;
  border-bottom: 1px solid #f0f0f0;
  vertical-align: middle;
}
.cl-level-table .cl-level-row:last-child td {
  border-bottom: none;
}
.cl-level-table .cl-level-row:hover {
  background: #f8f9fa;
}
.cl-level-table .cl-level-row--selected {
  background: #f0f7ff;
}
.cl-level-table .cl-level-row--selected td {
  border-bottom-color: #dceeff;
}
.cl-radio {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid #ced4da;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: border-color 0.12s;
}
.cl-radio--checked {
  border-color: #0d6efd;
  background:
    radial-gradient(
      circle,
      #0d6efd 40%,
      transparent 45%);
}
/*# sourceMappingURL=campaigns-limits.component-ALDVNLSK.css.map */
